import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\CreatorController::cancel
* @see app/Http/Controllers/Admin/CreatorController.php:291
* @route '/app/admin/creators/{creatorProfile}/subscriptions/{subscription}/cancel'
*/
export const cancel = (args: { creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } } | [creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: cancel.url(args, options),
    method: 'put',
})

cancel.definition = {
    methods: ["put"],
    url: '/app/admin/creators/{creatorProfile}/subscriptions/{subscription}/cancel',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\CreatorController::cancel
* @see app/Http/Controllers/Admin/CreatorController.php:291
* @route '/app/admin/creators/{creatorProfile}/subscriptions/{subscription}/cancel'
*/
cancel.url = (args: { creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } } | [creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            creatorProfile: args[0],
            subscription: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        creatorProfile: typeof args.creatorProfile === 'object'
        ? args.creatorProfile.uuid
        : args.creatorProfile,
        subscription: typeof args.subscription === 'object'
        ? args.subscription.uuid
        : args.subscription,
    }

    return cancel.definition.url
            .replace('{creatorProfile}', parsedArgs.creatorProfile.toString())
            .replace('{subscription}', parsedArgs.subscription.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\CreatorController::cancel
* @see app/Http/Controllers/Admin/CreatorController.php:291
* @route '/app/admin/creators/{creatorProfile}/subscriptions/{subscription}/cancel'
*/
cancel.put = (args: { creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } } | [creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: cancel.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::cancel
* @see app/Http/Controllers/Admin/CreatorController.php:291
* @route '/app/admin/creators/{creatorProfile}/subscriptions/{subscription}/cancel'
*/
const cancelForm = (args: { creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } } | [creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\CreatorController::cancel
* @see app/Http/Controllers/Admin/CreatorController.php:291
* @route '/app/admin/creators/{creatorProfile}/subscriptions/{subscription}/cancel'
*/
cancelForm.put = (args: { creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } } | [creatorProfile: string | { uuid: string }, subscription: string | { uuid: string } ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: cancel.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

cancel.form = cancelForm

const subscription = {
    cancel: Object.assign(cancel, cancel),
}

export default subscription